import React from 'react';
import Box from '@mui/material/Box';

export default function SalesTable(props) {
  const { title, subtitle, percent, comment, value, unit, children } = props;

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        boxShadow: 1,
        borderRadius: 2,
        width: 768
      }}
    >
      {children}
    </Box>
  );
}
